import { factory } from "../../../../utils/apiThunkFactory";

export const getDailySparks = factory.get("spark/getDailySparks", "/api/spark/get-daily-sparks-amount/:user_id");
export const getAllUsersToSpark = factory.get("spark/getAllUsersToSpark", "/api/spark/get-all-users-to-spark/:userSparkId");
export const sendSparks = factory.post("spark/sendSparks", "/api/spark/send-sparks");
export const getSparksData = factory.get("spark/getSparksData", "/api/spark/dashboardData");
export const getLeaderboardData = factory.get("spark/getLeaderboardData", "/api/spark/leader-board/:page");
export const sendEncouragement = factory.post("spark/sendEncouragement", "/api/spark/send-encouragement/:targetId");